<template>
    <div class="pastas" @click="$emit('adicionaDiretorio', titulo)">
        <i class="fa fa-folder icon-pasta" aria-hidden="true"></i>

        <span class="nome-pasta">{{titulo}}</span>
    </div>
</template>

<script>
    export default {
        props: {
            titulo: {
                type: String
            },
        },
    }
</script>

<style>
.pastas {
    cursor: pointer;
    width: 169px;
    min-height: 86px;
    padding: 6px;
    text-align: center;
    margin-right: 10px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Noto Sans', sans-serif;
}

.nome-pasta {
    margin-top: 8px;
    font-size: 13px;
}

.pastas:hover .nome-pasta {
    color: #116fbf;
}

.icon-pasta{
    font-size: 60px!important;
    color: rgb(146, 206, 255);
}
</style>